var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBathIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 384c0 28.32 12.49 53.52 32 71.09V496c0 8.8 7.16 16 16 16h32c8.8 0 16-7.2 16-16v-15.1h256V496c0 8.836 7.164 16 16 16h32c8.836 0 16-7.164 16-16v-40.9c19.51-17.57 32-42.77 32-71.09V352H32v32zm464-128H96V77.25c-.03-10.8 15-17.02 22.6-9.37l13.8 13.78c-8.8 26.94-3 52.84 11.8 71.54-6.3 6.3-6.4 16.6-.2 22.8l11.31 11.31c6.248 6.248 16.38 6.248 22.63 0l105.4-105.4c6.248-6.248 6.248-16.38 0-22.63l-11.31-11.31c-6.248-6.248-16.38-6.248-22.63 0-18.7-14.71-44.7-20.42-71.7-11.56l-13.8-13.77C149.5 8.25 129.6 0 109.3 0 66.66 0 32 34.66 32 77.25v178.8L16 256c-8.836 0-16 7.2-16 16v32c0 8.8 7.164 16 16 16h480c8.836 0 16-7.164 16-16v-32c0-8.8-7.2-16-16-16z",
    fill: "#177404",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathIcon);
export default __webpack_public_path__ + "static/media/bath_icon.f7d3d69148b0f2f439acdb9c4c0ba26e.svg";
export { ForwardRef as ReactComponent };